import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowRight, Sparkles } from 'lucide-react';

const ZeditCTA = () => {
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });
  return (
    <section ref={ref} id="contact" className="py-20 sm:py-32 relative">
      <div className="container mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="rounded-[32px] sm:rounded-[40px] bg-[var(--bg-secondary)] border border-[var(--border-subtle)] p-10 sm:p-16 lg:p-20 text-center relative overflow-hidden"
        >
          {/* Inner neon glows */}
          <div className="absolute top-[-100px] left-[10%] w-[300px] h-[300px] bg-[var(--accent-primary)] opacity-[0.10] rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-[-100px] right-[10%] w-[320px] h-[320px] bg-[var(--accent-primary)] opacity-[0.10] rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[var(--accent-bg)] border border-[var(--accent-primary)]/30 text-xs font-medium mb-7">
              <Sparkles className="w-3.5 h-3.5 text-[var(--accent-primary)]" />
              <span className="text-white">Build with us</span>
            </div>
            <h2 className="text-4xl sm:text-6xl lg:text-7xl font-black tracking-tight leading-[1.02] text-white max-w-3xl mx-auto">
              Ready to ship{' '}
              <span className="text-[var(--accent-primary)]">tangible growth?</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg font-light text-[var(--text-secondary)] max-w-2xl mx-auto leading-relaxed">
              Let&apos;s talk about your protocol, your goals, and which Zedit products fit best.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="mailto:hi@zedit.io?subject=Zedit%20Growth%20Inquiry"
                data-testid="zedit-cta-primary"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[var(--accent-primary)] text-black font-semibold text-base hover:scale-105 transition-transform"
                style={{ boxShadow: '0 12px 32px -8px rgba(218,255,1,0.45)' }}
              >
                Let&apos;s talk
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="mailto:hi@zedit.io"
                data-testid="zedit-cta-secondary"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[var(--bg-tertiary)] border border-[var(--border-subtle)] text-white font-semibold text-base hover:border-[var(--accent-primary)] hover:bg-[var(--accent-bg)] transition-all"
              >
                hi@zedit.io
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ZeditCTA;
